import { render, staticRenderFns } from "./SideBarOffshorePrintingCutting.vue?vue&type=template&id=2a47542f"
import script from "./SideBarOffshorePrintingCutting.vue?vue&type=script&lang=js"
export * from "./SideBarOffshorePrintingCutting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports